/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Text, Tooltip, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import AddOnsIcon from '@/assets/svg/add-ons-icon.svg?react';

interface AddOnsTooltipProps {
  addOns: any[];
  children?: React.ReactNode;
}

const AddOnsTooltip: FC<AddOnsTooltipProps> = ({ addOns, children }) => {
  if (!addOns || addOns.length === 0) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      label={
        <Box p={4} minW="240px" maxW="400px" bg="background.primary" borderRadius="md">
          <Text fontWeight="bold" fontSize="sm" mb={3} color="text.primary">
            Add-ons
          </Text>
          <VStack align="start" spacing={2}>
            {addOns.map((addon: any, idx: number) => (
              <Text key={idx} fontSize="xs" color="text.primary">
                <Text as="span" fontWeight="medium">
                  {addon.name}
                </Text>
                {addon.weight && (
                  <Text as="span" color="text.secondary" ml={2}>
                    ({addon.weight} kg)
                  </Text>
                )}
              </Text>
            ))}
          </VStack>
        </Box>
      }
      bg="background.primary"
      color="text.secondary"
      fontSize="xs"
      hasArrow
      placement="bottom"
      arrowSize={10}
    >
      {children || (
        <Box
          as="span"
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          w="20px"
          h="20px"
          cursor="pointer"
          bg="background.tertiary"
          borderRadius="sm"
        >
          <Box as={AddOnsIcon} w="16px" h="16px" />
        </Box>
      )}
    </Tooltip>
  );
};

export default AddOnsTooltip;
